export enum CaseTaskOperation {
  Edit,
  Delete,
}
